export default __webpack_public_path__ + "static/media/02.697b47ef.jpg";